import { getButtonStylesWithAccentColor, getSolidButtonStylesWithAccentAndTextColor, useColorPaletteProvider } from '@apps/guest';
import { getButtonOutlineStylesWithAccentColorAndTextColor } from '@apps/guest/packages/layout-engine/layouts/layout.utils';
import { useTheme } from '@withjoy/joykit';

// Gets nav button styles.
// Uses guest site colors if available, otherwise falls back to default theme colors.
export const useNavButtonStyles = (guestStyles?: ReturnType<typeof useColorPaletteProvider>) => {
  const { colors } = useTheme();

  let pageColor = colors.newUIBrandPrimary;
  let pageFontColor = colors.white;

  if (guestStyles?.pageColor && guestStyles?.accentColor) {
    pageColor = guestStyles.pageColor;
    pageFontColor = guestStyles.accentColor;
  }

  const solidButtonStyles = getSolidButtonStylesWithAccentAndTextColor(pageColor, pageFontColor);
  const ghostButtonStyles = getButtonStylesWithAccentColor(pageColor);
  const outlineButtonStyles = getButtonOutlineStylesWithAccentColorAndTextColor(pageColor, pageFontColor);

  return { solidButtonStyles, ghostButtonStyles, outlineButtonStyles };
};
